module.exports = __webpack_public_path__ + "static/media/LifeTest.c0e1687c.svg";